/* States classes that can be added on the html root element */
export default {
  modal: 's--modal',
  overlay: 's--overlay',
  editor: 's--in-editor',
  search: 's--search'
}
